import type { QueryClient } from "@tanstack/react-query";
import User, { userFromResponse } from "../../types/user";
import { Storage } from "../../storage";

/**
 * Makes a sign-in payload the current session: persists it and re-syncs
 * `authAtom`. Every path that ends a login goes through here so the enrol
 * forms can hold a confirmed payload back until the user has seen their
 * backup codes, then commit it exactly as useLogin would have.
 */
export function commitLoginSession(
  queryClient: QueryClient,
  payload: { data?: unknown } | null | undefined,
): User | null {
  const user = userFromResponse(payload?.data);
  if (user) {
    Storage.setCurrentUser(JSON.stringify(user));
    queryClient.invalidateQueries({ queryKey: ["userSync"] });
  }
  return user;
}
